"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const ccMobileLandscapeViewStyle = (0, _react.useMemo)(() => {
    const landscapeImageRotate = (0, _css.keyframes)`
        0% { transform: rotate(0deg); }
        25% { transform: rotate(45deg); }
        75% { transform: rotate(45deg); }
        100% { transform: rotate(0deg); }
    `;
    const landscapeImageV = (0, _css.keyframes)`
        0% { opacity: 0; }
        25% { opacity: 0; }
        50% { opacity: 1; }
        75% { opacity: 0; }
        100% { opacity: 0; }
    `;
    const svgProps = () => {
      return {
        position: 'relative',
        height: '60%',
        top: '20%',
        width: '75%',
        animationName: landscapeImageRotate,
        animationDuration: '2.5s',
        animationIterationCount: 'infinite',
        '.path1': {
          fill: 'none',
          stroke: themeColors?.primary.light,
          strokeWidth: 11,
          strokeLinecap: 'square',
          strokeMiterlimit: 10
        },
        '.path2': {
          fill: 'none',
          stroke: themeColors?.primary.light,
          strokeWidth: 11,
          strokeMiterlimit: 10,
          opacity: 0,
          animationName: landscapeImageV,
          animationDuration: '2.5s',
          animationIterationCount: 'infinite'
        },
        '.path3': {
          fill: themeColors?.primary.light
        }
      };
    };
    const ccMobileLandscapeView = (0, _css.css)({
      display: 'block',
      background: themeColors?.primary.main,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 92147483647,
      textAlign: 'center',
      svg: {
        ...svgProps()
      }
    });
    const ccMobileLandscapeViewMessage = (0, _css.css)({
      display: 'block',
      position: 'absolute',
      color: themeColors?.primary.light,
      left: 0,
      right: 0,
      top: '82%',
      marginLeft: 'auto',
      marginRight: 'auto',
      fontFamily: 'AlmoniNeon',
      fontSize: '1.5rem',
      maxWidth: '45%'
    });
    return {
      ccMobileLandscapeView,
      ccMobileLandscapeViewMessage
    };
  }, [themeColors]);
  return {
    'cc-MobileLandscapeView': ccMobileLandscapeViewStyle.ccMobileLandscapeView,
    'cc-MobileLandscapeViewMessage': ccMobileLandscapeViewStyle.ccMobileLandscapeViewMessage
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;